module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "summaryReporting": ""
    }
  }, [_c('v-form', [(_vm.loading) ? _c('center', [_c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  })]) : _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('span', {
    staticClass: "sr-dates"
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep",
    attrs: {
      "id": "dashDate",
      "valueType": "format",
      "placeholder": "Summary Start Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    model: {
      value: (_vm.startDate_summary),
      callback: function($$v) {
        _vm.startDate_summary = $$v
      },
      expression: "startDate_summary"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "sr-dates"
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("End Date "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v("(cannot exceed 12 months)")])]), _vm._v(" "), _c('date-picker', {
    staticClass: "quoteDateRep dashDateRep input-error",
    attrs: {
      "id": "dashDate",
      "valueType": "format",
      "placeholder": "Summary End Date",
      "format": "YYYY-MM-DD",
      "lang": "en"
    },
    on: {
      "change": function($event) {
        return _vm.fncValidateDateRange($event)
      }
    },
    model: {
      value: (_vm.endDate_summary),
      callback: function($$v) {
        _vm.endDate_summary = $$v
      },
      expression: "endDate_summary"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "sr-dates setdate"
  }, [_c('label', {
    staticClass: "blackLabel"
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    staticStyle: {
      "float": "left",
      "display": "block",
      "top": "12px"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnSetDate()
      }
    }
  }, [_vm._v("SET DATE")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), (_vm.fncCheckDone('status')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "statusSelect",
    staticClass: "shortSelect",
    attrs: {
      "item-disabled": "disable",
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('status'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "ou": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('status')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'status')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'status')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objStatus.length - 1) + " others)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.objStatus),
      callback: function($$v) {
        _vm.objStatus = $$v
      },
      expression: "objStatus"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), (_vm.fncCheckDone('service_type')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "serviceTypeSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('service_type'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('service_type')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'service_type')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'service_type')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objServiceType.length - 1) + " others)\n              ")]) : _vm._e()]
      }
    }], null, false, 1239619202),
    model: {
      value: (_vm.objServiceType),
      callback: function($$v) {
        _vm.objServiceType = $$v
      },
      expression: "objServiceType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Departments")])]), _vm._v(" "), (_vm.fncCheckDone('department')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "departmentSelect",
    staticClass: "shortSelect",
    attrs: {
      "item-disabled": "disable",
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('department'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('department')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'department')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'department')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.obj_Departments.length - 1) + " others)")]) : _vm._e()]
      }
    }], null, false, 629691869),
    model: {
      value: (_vm.obj_Departments),
      callback: function($$v) {
        _vm.obj_Departments = $$v
      },
      expression: "obj_Departments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Vendor")])]), _vm._v(" "), (_vm.fncCheckDone('vendor')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "vendorSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('vendor'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('vendor')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'vendor')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'vendor')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objVendor.length - 1) + " others)")]) : _vm._e()]
      }
    }], null, false, 139811857),
    model: {
      value: (_vm.objVendor),
      callback: function($$v) {
        _vm.objVendor = $$v
      },
      expression: "objVendor"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Roles")])]), _vm._v(" "), (_vm.fncCheckDone('role')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "roleSelect",
    staticClass: "shortSelect",
    attrs: {
      "item-disabled": "disable",
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('roles'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('roles')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'role')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'role')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.role.length - 1) + " others)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Quote Type")])]), _vm._v(" "), (_vm.fncCheckDone('quote_type')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "quoteTypeSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('quote_type'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('quote_type')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'quote_type')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'quote_type')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objQuoteType.length - 1) + " others)")]) : _vm._e()]
      }
    }], null, false, 1659552119),
    model: {
      value: (_vm.objQuoteType),
      callback: function($$v) {
        _vm.objQuoteType = $$v
      },
      expression: "objQuoteType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Regions")])]), _vm._v(" "), (_vm.fncCheckDone('region')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "regionSelect",
    staticClass: "shortSelect",
    attrs: {
      "item-disabled": "disable",
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('region'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('region')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'region')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'region')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objRegion.length - 1) + " others)\n              ")]) : _vm._e()]
      }
    }], null, false, 2868968479),
    model: {
      value: (_vm.objRegion),
      callback: function($$v) {
        _vm.objRegion = $$v
      },
      expression: "objRegion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Store")])]), _vm._v(" "), (_vm.fncCheckDone('store')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "storeSelect",
    class: _vm.disableButton('store') ? 'shortSelect red_borders' : 'shortSelect',
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('store'),
      "item-text": "name",
      "item-value": "id",
      "autocomplete": "",
      "multiple": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('store')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'store')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'store')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objStore.length - 1) + " others)")]) : _vm._e()]
      }
    }], null, false, 639787498),
    model: {
      value: (_vm.objStore),
      callback: function($$v) {
        _vm.objStore = $$v
      },
      expression: "objStore"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Responsible Rep")])]), _vm._v(" "), (_vm.fncCheckDone('rep')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "repSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('rep'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('rep')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'rep')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'rep')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objRep.length - 1) + " others)")]) : _vm._e()]
      }
    }], null, false, 605039058),
    model: {
      value: (_vm.objRep),
      callback: function($$v) {
        _vm.objRep = $$v
      },
      expression: "objRep"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Originator")])]), _vm._v(" "), (_vm.fncCheckDone('originator')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "originatorSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('originator'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('originator')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'originator')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'originator')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objOriginator.length - 1) + " others)\n              ")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.objOriginator),
      callback: function($$v) {
        _vm.objOriginator = $$v
      },
      expression: "objOriginator"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Customer")])]), _vm._v(" "), (_vm.fncCheckDone('customer')) ? _c('a', {
    staticClass: "filterDone",
    on: {
      "click": function($event) {
        return _vm.fncReloadFilters()
      }
    }
  }, [_vm._v("Done")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    ref: "customerSelect",
    staticClass: "shortSelect",
    attrs: {
      "prepend-icon": "search",
      "items": _vm.fncSetFiltersSummary('customer'),
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckDropdownsAllCheck('customer')
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(_vm.displayChip(index, 'customer')) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (_vm.displayText(index, 'customer')) ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objCustomerUser.length - 1) + " others)")]) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.objCustomerUser),
      callback: function($$v) {
        _vm.objCustomerUser = $$v
      },
      expression: "objCustomerUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "reporting-measurements",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Reporting Measurements")])]), _vm._v(" "), _c('v-select', {
    staticClass: "shortSelect reportingDropdown",
    attrs: {
      "items": _vm.measurements,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.objMeasurement),
      callback: function($$v) {
        _vm.objMeasurement = $$v
      },
      expression: "objMeasurement"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    staticClass: "reporting-category",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Category")])]), _vm._v(" "), _c('v-select', {
    staticClass: "shortSelect reportingDropdown",
    attrs: {
      "value": _vm.objCategory,
      "prepend-icon": "search",
      "items": _vm.category,
      "item-text": "name",
      "item-value": "id",
      "multiple": "",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "change": function($event) {
        return _vm.fncCheckDropdowns('category', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [(index === 0) ? _c('v-chip', [_c('span', [_vm._v(_vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (index === 1 && _vm.objCategory[0] !== 'all') ? _c('span', {
          staticClass: "grey--text caption"
        }, [_vm._v("(+" + _vm._s(_vm.objCategory.length - 1) + " others)\n                ")]) : _vm._e()]
      }
    }], null, false, 3601245336)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "reporting-increment",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("Reporting Increment")])]), _vm._v(" "), _c('v-select', {
    staticClass: "shortSelect reportingDropdown",
    attrs: {
      "items": _vm.rep_increment,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.objIncrement),
      callback: function($$v) {
        _vm.objIncrement = $$v
      },
      expression: "objIncrement"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative",
      "margin-top": "5px",
      "font-size": "16px"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('label', {
    staticClass: "mTop"
  }, [_c('b', [_vm._v("REPORT TYPE")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative",
      "margin-top": "5px",
      "font-size": "16px",
      "padding-left": "31px !important"
    },
    attrs: {
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "switch-container"
  }, [(_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('div', {
    staticClass: "left-label"
  }, [_c('label', [_vm._v(" Origination ")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-switch', {
    attrs: {
      "label": "Conversions"
    },
    on: {
      "change": _vm.setModeDate
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "d-flex",
    staticStyle: {
      "position": "relative",
      "margin-top": "5px",
      "font-size": "16px"
    },
    attrs: {
      "md3": ""
    }
  }, [(_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-switch', {
    staticStyle: {
      "float": "right",
      "display": "block",
      "margin-bottom": "-20px !important"
    },
    attrs: {
      "label": "Show Zeros"
    },
    model: {
      value: (_vm.show_zero),
      callback: function($$v) {
        _vm.show_zero = $$v
      },
      expression: "show_zero"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative",
      "float": "right",
      "margin-top": "5px"
    },
    attrs: {
      "md2": ""
    }
  }, [(!_vm.value) ? _c('v-toolbar-side-icon', {
    staticStyle: {
      "float": "right",
      "margin-top": "0px"
    },
    attrs: {
      "disabled": _vm.oldSummaryReport('summary'),
      "color": "white",
      "right": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.drawer) ? _c('v-navigation-drawer', {
    staticStyle: {
      "margin-top": "510px",
      "width": "170px",
      "margin-right": "50px",
      "padding": "0px !important",
      "height": "auto !important"
    },
    attrs: {
      "disabled": _vm.oldSummaryReport('summary'),
      "clipped": "",
      "bottom": "",
      "hide-overlay": "",
      "app": "",
      "right": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('div', {}, [(!_vm.oldSummaryReport('summary')) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerateSummaryReport()
      }
    }
  }, [_vm._v("Resource Summary Report")])], 1)], 1) : _vm._e()], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative",
      "text-align": "center",
      "display": "none"
    },
    attrs: {
      "md6": ""
    }
  }, [_c('label', {
    staticClass: "mTop",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v("Leads, Quotes and Sales by Origination Date")])])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "position": "relative",
      "text-align": "center",
      "display": "none"
    },
    attrs: {
      "md6": ""
    }
  }, [(_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('label', {
    staticClass: "mTop",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v("Sales by Conversion Date")])]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "align-end d-flex leadsButtons",
    staticStyle: {
      "position": "relative",
      "padding-top": "20px !important"
    },
    attrs: {
      "md5.7": ""
    }
  }, [_c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.department && _vm.newReportFilters.department.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 ",
    staticStyle: {
      "background-color": "#333333 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.department.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('department', 'Origination')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/department_white.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom report_button"
  }, [_vm._v("Department")])]), _vm._v(" "), (_vm.report_type == 2) ? _c('span', [_vm._v("Currently on Conversion report")]) : _c('span', [_vm._v("Department data missing")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.roles.store <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4",
    staticStyle: {
      "background-color": "#333333 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.store.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('store', 'Origination')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/region_white.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom report_button"
  }, [_vm._v("Region/Store")])]), _vm._v(" "), (_vm.report_type == 2) ? _c('span', [_vm._v("Currently on Conversion report")]) : _c('span', [_vm._v("Region/Store data missing")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "top": "",
      "disabled": !(_vm.newReportFilters.roles.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2 || (_vm.show_zero && (_vm.obj_Departments[0] === 'all' || _vm.role[0] === 'all')))
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 ",
    staticStyle: {
      "background-color": "#333333 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (Object.keys(_vm.newReportFilters.roles).length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2 || (_vm.show_zero && (_vm.obj_Departments[0] === 'all' || _vm.role[0] === 'all'))),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('role', 'Origination')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/role_white.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom report_button"
  }, [_vm._v("Role")])]), _vm._v(" "), (_vm.report_type == 2) ? _c('span', [_vm._v("Currently on Conversion report")]) : (_vm.show_zero) ? _c('span', [_vm._v("Please choose at least one department or role")]) : _c('span', [_vm._v("Role data missing")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.originator.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 ",
    staticStyle: {
      "background-color": "#333333 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.originator.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('originator', 'Origination')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/originator_white.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom report_button"
  }, [_vm._v("Originator")])]), _vm._v(" "), (_vm.report_type == 2) ? _c('span', [_vm._v("Currently on Conversion report")]) : _c('span', [_vm._v("Originator data missing ")])], 1), _vm._v(" "), _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.vendor.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 ",
    staticStyle: {
      "background-color": "#333333 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.vendor.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 2),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('vendor', 'Origination')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/vendor_white.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom report_button"
  }, [_vm._v("Vendor")])]), _vm._v(" "), (_vm.report_type == 2) ? _c('span', [_vm._v("Currently on Conversion report")]) : _c('span', [_vm._v("Vendor data missing ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "align-start d-flex",
    staticStyle: {
      "position": "relative",
      "padding-top": "0px !important"
    },
    attrs: {
      "md0.1": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "align-end d-flex salesButtons",
    staticStyle: {
      "position": "relative",
      "padding-top": "20px !important"
    },
    attrs: {
      "md5.7": ""
    }
  }, [(_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.department.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 second_btton_color",
    staticStyle: {
      "background-color": "#ffd600 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.department.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('department', 'conversion')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/department_black.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top_conversion report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom_conversion report_button"
  }, [_vm._v("Department")])]), _vm._v(" "), (_vm.report_type == 1) ? _c('span', [_vm._v("Currently on Origination report")]) : _c('span', [_vm._v("Department data missing")])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.store.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 second_btton_color",
    staticStyle: {
      "background-color": "#ffd600 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.store.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('store', 'conversion')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/region_black.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top_conversion report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom_conversion report_button"
  }, [_vm._v("Region/Store")])]), _vm._v(" "), (_vm.report_type == 1) ? _c('span', [_vm._v("Currently on Origination report")]) : _c('span', [_vm._v("Region/Store data missing")])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "top": "",
      "disabled": !(_vm.newReportFilters.roles.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1 || (_vm.show_zero && (_vm.obj_Departments[0] === 'all' || _vm.role[0] === 'all')))
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 second_btton_color",
    staticStyle: {
      "background-color": "#ffd600 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.roles.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1 || (_vm.show_zero && (_vm.obj_Departments[0] === 'all' || _vm.role[0] === 'all'))),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('role', 'conversion')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/role_black.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top_conversion report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom_conversion report_button"
  }, [_vm._v("Role")])]), _vm._v(" "), (_vm.report_type == 1) ? _c('span', [_vm._v("Currently on Origination report")]) : (_vm.show_zero) ? _c('span', [_vm._v("Please choose at least one department or role")]) : _c('span', [_vm._v("Role data missing")])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.originator.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 second_btton_color",
    staticStyle: {
      "background-color": "#ffd600 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.originator.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('originator', 'conversion')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/originator_black.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top_conversion report_button"
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom_conversion report_button"
  }, [_vm._v("Originator")])]), _vm._v(" "), (_vm.report_type == 1) ? _c('span', [_vm._v("Currently on Origination report")]) : _c('span', [_vm._v("Originator data missing ")])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_NEW_WORK') != -1) ? _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "disabled": !(_vm.newReportFilters.vendor.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "top": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-4 second_btton_color",
    staticStyle: {
      "background-color": "#ffd600 !important",
      "min-width": "100px",
      "width": "94%",
      "height": "100px",
      "border-radius": "10px!important",
      "pointer-events": "all !important"
    },
    attrs: {
      "slot": "activator",
      "disabled": (_vm.newReportFilters.vendor.length <= 0 || _vm.objCategory.length <= 0 || _vm.report_type == 1),
      "id": "new_align"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerate('vendor', 'conversion')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "report_image report_button",
    attrs: {
      "align": "center",
      "src": require("../../shared/assets/images/vendor_black.png")
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label_tile_top_conversion report_button "
  }, [_vm._v("By")]), _vm._v(" "), _c('label', {
    staticClass: "label_tile_bottom_conversion report_button"
  }, [_vm._v("Vendor")])]), _vm._v(" "), (_vm.report_type == 1) ? _c('span', [_vm._v("Currently on Origination report")]) : _c('span', [_vm._v("Vendor data missing ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncClearFilter()
      }
    }
  }, [_vm._v("CLEAR FILTERS")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}